import styled from '@emotion/styled';
import { mediaQueries } from '../mediaQueries';

export const PageWrapper = styled.div`
  display: grid;
  max-width: 1400px;
  margin: 0 auto;
  ${mediaQueries.desktop} {
    place-items: center;
  }
`;
